import { GcpBox, GcpQrCard } from '@back-office/ui';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useViewModel from './viewmodel';

const useStyles = makeStyles(
  (theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: theme.palette.common.ceriseRed,
    },
    button: {
      color: theme.palette.common.hitGray,
    },
    icon: {
      marginLeft: theme.spacing(2),
      width: theme.spacing(2),
    },
  }),
  { name: 'GeneratedQRCode' }
);

const GeneratedQRCode: FC = observer(() => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { state, invoice, detail } = useViewModel();

  return (
    <Container>
      <GcpBox display="flex" justifyContent="center" mt={9}>
        <GcpQrCard
          amount={invoice.amount}
          currency={invoice.currency}
          description={invoice.description}
          handleClose={state.handleOnCancel}
          isSuccess={state.isPollingSuccess}
          loading={state.isLoading}
          merchantName={invoice.merchantName}
          qr={invoice.qr}
          ref1={invoice.ref1}
          ref2={invoice.ref2}
          tidDetail={detail}
        />
      </GcpBox>
      {state.isPollingSuccess && (
        <GcpBox display="flex" justifyContent="center" mt={5}>
          <Button className={classes.button} onClick={state.handleOnClick}>
            {t('qr.go_to_transaction')}
            <ArrowForwardIcon className={classes.icon} />
          </Button>
        </GcpBox>
      )}
    </Container>
  );
});

export default GeneratedQRCode;
